var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.35,193.77H151a2.94,2.94,0,0,1-2.84-2.08l-3.52-10.83a3,3,0,0,0-5.69,0l-3.33,10.6a2.94,2.94,0,0,1-2.85,2.08H122.33a3,3,0,0,0-1.76,5.37l9,6.72a3,3,0,0,1,1.09,3.34l-3.52,10.83a3,3,0,0,0,4.51,3.34l9-6.72a3,3,0,0,1,3.52,0l9,6.72a3,3,0,0,0,4.51-3.34L154.23,209a3,3,0,0,1,1.08-3.34l9-6.72a3,3,0,0,0-2-5.14Z",
    fill: "#300b5c",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.22,135.2a42.1,42.1,0,1,0-42-42.69v.09A42.33,42.33,0,0,0,143.22,135.2Zm0-68.27h0a25.4,25.4,0,0,1,25.22,25.58v.4a25.63,25.63,0,1,1-25.26-26Z",
    fill: "#300b5c",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.73,140.88c-44.31,0-79.95,37.14-79.95,82.53a8.44,8.44,0,1,0,16.83,0A64.34,64.34,0,0,1,141.78,158a64.36,64.36,0,0,1,63.08,65.43,8.44,8.44,0,1,0,16.83,0C221.69,178,186,140.88,141.73,140.88Z",
    fill: "#300b5c",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard14);
export default __webpack_public_path__ + "static/media/card1_4.d71338197ebc4b4897b1a5e31b2c5944.svg";
export { ForwardRef as ReactComponent };